import { IEquipment } from '@/pages/Equipment/equipment.types'
import parametersSelectors from '@/pages/Parameters/parameters.selectors'
import { useRecoilValue } from 'recoil'
import LiftIndicatorsWidget from '../LiftIndicatorsWidget'
import liftIndicatorsConfig from '../liftIndicators.config'
import useParametersValuesRange from '@/services/data/hooks/useParametersValuesRange'
import { useMemo } from 'react'

interface IProps {
  equipmentId: IEquipment['id']

  tsFrom: number
  tsTo: number
  tsCurrent: number
}

const LiftIndicatorsRange = (props: IProps) => {
  const sourceIdToIdMap = useRecoilValue(parametersSelectors.getSourceIdToIdMap)

  const config = useMemo(
    () => ({
      tsFrom: props.tsFrom,
      tsTo: props.tsTo,
      equipmentId: props.equipmentId,
      parameters: liftIndicatorsConfig.indicatorsParameters.map((sourceId) => sourceIdToIdMap[sourceId]),
    }),
    [sourceIdToIdMap, props.tsFrom, props.equipmentId, props.tsTo]
  )

  const ctrl = useParametersValuesRange({
    ...config,
    tsCurrent: props.tsCurrent,
  })

  return <LiftIndicatorsWidget values={ctrl.values} loading={ctrl.loading} />
}

export default LiftIndicatorsRange
